import { useMemo } from 'react';
import { qrMatrix, qrPath } from '../lib/qr';

const QUIET_ZONE = 4;

/**
 * The QR code of an EMVCo payload as one SVG path (crisp at any size, prints sharp). Black on
 * white in both themes: scanners need the contrast and the quiet zone.
 */
export function QrCode({ payload, label, size = 240 }: { payload: string; label: string; size?: number }) {
  const { path, dim } = useMemo(() => {
    const m = qrMatrix(payload);
    return { path: qrPath(m, QUIET_ZONE), dim: m.size + QUIET_ZONE * 2 };
  }, [payload]);
  return (
    <svg
      className="qr"
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`0 0 ${dim} ${dim}`}
      shapeRendering="crispEdges"
      data-testid="qr-svg"
    >
      <rect width={dim} height={dim} fill="#FFFFFF" />
      <path d={path} fill="#000000" />
    </svg>
  );
}
